module.exports = __webpack_public_path__ + "media/images/logo_white-9112ebacbc0c97b9e38fb9520eda7bb8.svg";